import { apiMethod } from '../../../shared/api-method';
import { APINames } from 'src/shared';
import { getDataType, reportErrorLog } from '../../utils';
const apiName = 'onBluetoothDeviceFound';

// 监听搜索到新设备的事件。
export function onBluetoothDeviceFound(listener: Function) {
  if (getDataType(listener) !== 'Function') {
    reportErrorLog(apiName, 'callback is not a function');
    return;
  }
  apiMethod.on(APINames.Native.ON_BLUETOOTH_DEVICE_FOUND, listener);
}
